import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private store: Store<{ config: any }>
  ) {}

  /**
   * Wait to load languages from API
   * Provide languages to NGRX store and then load app
   */
  load(): Promise<any> {
    return new Promise<any>((resolve) => {
      // this.getAppSettings().subscribe((response: any) => {
      //   const languages = response.data
      //     .map((lang: Language) => {
      //       return {
      //         name: lang.name,
      //         code: lang.locale,
      //         active: lang.active,
      //         id: lang.id,
      //       };
      //     })
      //     .filter((lang: Language) => lang.active === true);
      //   localStorage.setItem('languages', JSON.stringify(languages));
      //   /**
      //    * * Set default language to 'en'
      //    */
      if (!localStorage.getItem('cmsLanguage')) {
        localStorage.setItem('cmsLanguage', 'en');
        this.translate.use('en');
      } else {
        this.translate.use(localStorage.getItem('cmsLanguage'));
      }
      //   this.store.dispatch(
      //     setConfig({ langs: languages, allLangs: response.data })
      //   );
      resolve({});
      // });
    });
  }

  /**
   * @param settingsField Pass what settings you want to get from API
   * @returns Settings from API
   */
  getAppSettings() {
    return this.http.get(`${environment.apiUrl}/api/configuration`);
  }
}
